import { render, staticRenderFns } from "./ProyectoEstados.vue?vue&type=template&id=72e7f2c4&"
import script from "./ProyectoEstados.vue?vue&type=script&lang=js&"
export * from "./ProyectoEstados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports